import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, CalendarCheck, Check } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (iso) => (iso ? new Date(iso).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');
const SRC = { create_listing_large: 'Create listing', claim_large: 'Claim' };

const Status = ({ r }) => {
  if (r.booked) return <Badge className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100" data-testid={`stopped-status-${r.id}`}><CalendarCheck className="w-3 h-3 mr-1" />Booked {fmt(r.booking_start)}</Badge>;
  if (r.requested_call_at) return <Badge className="bg-sky-100 text-sky-800 hover:bg-sky-100" data-testid={`stopped-status-${r.id}`}>Asked for a call</Badge>;
  if (r.clicked_book_at) return <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100" data-testid={`stopped-status-${r.id}`}>Opened booking, no booking</Badge>;
  return <Badge className="bg-gray-100 text-gray-700 hover:bg-gray-100" data-testid={`stopped-status-${r.id}`}>Not booked</Badge>;
};

export const StoppedCheckoutTab = ({ onCount }) => {
  const [rows, setRows] = useState(null);
  const load = () => axios.get(`${API}/admin/sales-gate/stopped`).then((r) => { setRows(r.data.items); onCount?.(r.data.items.length); }).catch(() => setRows([]));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const chase = async (r) => {
    try { await axios.post(`${API}/admin/sales-gate/stopped/${r.id}/chased`, { chased: !r.chased }); load(); toast.success(r.chased ? 'Marked not chased' : 'Marked chased'); }
    catch { toast.error('Could not update'); }
  };
  if (!rows) return <div className="flex justify-center py-10"><Loader2 className="w-5 h-5 animate-spin text-gray-400" /></div>;
  return (
    <Card data-testid="stopped-checkout-tab"><CardContent className="p-0 overflow-x-auto">
      <p className="text-xs text-gray-500 px-4 pt-4">Suppliers above the self-serve limit who reached "Book a call" at checkout. Lizzie gets an email 30 minutes later if they haven't booked.</p>
      {rows.length === 0 ? <p className="text-sm text-gray-500 p-4" data-testid="stopped-empty">Nobody has been stopped at checkout yet.</p> : (
        <table className="w-full text-sm mt-2">
          <thead><tr className="text-left text-xs text-gray-500 uppercase tracking-wider border-b">
            <th className="px-4 py-2">Supplier</th><th className="px-2">Staff</th><th className="px-2">Where</th><th className="px-2">When</th><th className="px-2">Status</th><th className="px-4" /></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className={`border-b last:border-0 align-top ${r.chased ? 'opacity-60' : ''}`} data-testid={`stopped-row-${r.id}`}>
                <td className="px-4 py-3"><div className="font-medium text-gray-900">{r.company || 'Unknown company'}</div>
                  <div className="text-xs text-gray-500">{r.name ? `${r.name} · ` : ''}<a href={`mailto:${r.email}`} className="text-[#00857D] hover:underline">{r.email}</a></div></td>
                <td className="px-2 py-3 text-gray-700">{r.staff_count || '-'}</td>
                <td className="px-2 py-3 text-gray-600">{SRC[r.source] || r.source}</td>
                <td className="px-2 py-3 text-gray-600 whitespace-nowrap">{fmt(r.created_at)}{r.alerted ? <div className="text-[11px] text-gray-400">Alert sent</div> : null}</td>
                <td className="px-2 py-3"><Status r={r} /></td>
                <td className="px-4 py-3 text-right">
                  <button type="button" onClick={() => chase(r)} data-testid={`stopped-chase-${r.id}`}
                    className={`inline-flex items-center gap-1 text-xs font-semibold rounded-md px-3 py-1.5 transition-colors ${r.chased ? 'bg-emerald-50 text-emerald-700' : 'border border-[#00A79D] text-[#00857D] hover:bg-[#00A79D]/5'}`}>
                    {r.chased ? <><Check className="w-3 h-3" /> Chased{r.chased_by ? ` by ${r.chased_by.split(' ')[0]}` : ''}</> : 'Mark chased'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </CardContent></Card>
  );
};
